import { service } from "../utils/request";

// 商品
export function productList(data) {
  return service({
    url: "creditshop/agent.Creditshop_Goods/index",
    method: "post",
    data: data
  });
}
export function deleteProduct(data) {
  return service({
    url: "creditshop/agent.Creditshop_Goods/del",
    method: "post",
    data: data
  });
}
export function addProduct(data) {
  return service({
    url: "creditshop/agent.Creditshop_Goods/add",
    method: "post",
    data: data
  });
}
export function editProduct(data) {
  return service({
    url: "creditshop/agent.Creditshop_Goods/edit",
    method: "post",
    data: data
  });
}
export function detailProduct(data) {
  return service({
    url: "creditshop/agent.Creditshop_Goods/detail",
    method: "post",
    data: data
  });
}
// 订单列表
export function orderList(data) {
  return service({
    url: "creditshop/agent.Creditshop_Goods_Order/index",
    method: "post",
    data: data
  });
}
export function exportOrder(data) {
  return service({
    url: "creditshop/agent.Creditshop_Goods_Order/export",
    method: "post",
    data: data
  });
}
//核销
export function orderVerifiy(data) {
  return service({
    url: "creditshop/agent.Creditshop_Goods_Order/verifiy",
    method: "post",
    data: data
  });
}
// 删除
export function orderDelete(data) {
  return service({
    url: "creditshop/agent.CreditshopGoodsOrder/del",
    method: "post",
    data: data
  });
}
//改变积分商品上下架/开启联盟商品开关
export function allianceProductStatus(data) {
  return service({
    url: "creditshop/agent.creditshop_goods/openStatus",
    method: "post",
    data: data
  });
}
//选品库
export function integral_goods_list(data) {
  return service({
    url: "manage/goods.goods/index",
    method: "post",
    data: data
  });
}
export function seting_integral_goods(data) {
  return service({
    url: "manage/goods.setting/index",
    method: "post",
    data: data
  });
}
export function edit_setting(data) {
  return service({
    url: "manage/goods.setting/edit",
    method: "post",
    data: data
  });
}
export function check_goods(data) {
  return service({
    url: "manage/goods.goods/choose",
    method: "post",
    data: data
  });
}
export function remove_goods(data) {
  return service({
    url: "manage/goods.goods/remove",
    method: "post",
    data: data
  });
}

export function removeAll(data) {
  return service({
    url: "manage/goods.goods/removeAll",
    method: "post",
    data: data
  });
}

export function chooseAll(data) {
  return service({
    url: "manage/goods.goods/chooseAll",
    method: "post",
    data: data
  });
}

export function category_list(data) {
  return service({
    url: "manage/goods.goods/cate",
    method: "post",
    data: data
  });
}
export function IntegralOrder_list(data) {
  return service({
    url: "manage/goods.order/order_list",
    method: "post",
    data: data
  });
}
export function IntegralOrder_Info(data) {
  return service({
    url: "manage/goods.order/order_detail",
    method: "post",
    data: data
  });
}
export function IntegralOrder_count(data) {
  return service({
    url: "manage/goods.order/order_count",
    method: "post",
    data: data
  });
}
export function settle_list(data) {
  return service({
    url: "manage/goods.order/settle_list",
    method: "post",
    data: data
  });
}
export function settle_count(data) {
  return service({
    url: "manage/goods.order/settle_count",
    method: "post",
    data: data
  });
}
export function settlement_bonus(data) {
  return service({
    url: "manage/order.bonus/settlement",
    method: "post",
    data: data
  });
}
export function settlement_logs(data) {
  return service({
    url: "manage/order.bonus/settlement_logs",
    method: "post",
    data: data
  });
}
export function settlement_detail_list(data) {
  return service({
    url: "manage/order.bonus/settlement_detail_list",
    method: "post",
    data: data
  });
}
export function settlement_logs_count(data) {
  return service({
    url: "manage/order.bonus/settlement_logs_count",
    method: "post",
    data: data
  });
}
export function settlement_detail_count(data) {
  return service({
    url: "manage/order.bonus/settlement_detail_count",
    method: "post",
    data: data
  });
}
export function settlement_pay(data) {
  return service({
    url: "manage/order.bonus/settlement_pay",
    method: "post",
    data: data
  });
}
export function check_status(data) {
  return service({
    url: "manage/order.bonus/check_status",
    method: "post",
    data: data
  });
}
export function app_recharge(data) {
  return service({
    url: "manage/order.bonus/app_recharge",
    method: "post",
    data: data
  });
}
export function app_recharge_logs(data) {
  return service({
    url: "manage/order.bonus/app_wallet_logs",
    method: "post",
    data: data
  });
}
export function app_recharge_status(data) {
  return service({
    url: "manage/order.bonus/recharge_check_status",
    method: "post",
    data: data
  });
}
export function app_wallet(data) {
  return service({
    url: "manage/order.bonus/app_wallet",
    method: "post",
    data: data
  });
}
